export default "__VITE_ASSET__JMhYF65R__"